export const blockReasons = [
  'Контактні дані та посилання на зовнішні ресурси в не призначених для цього полях',
  'Бажану посаду неточно описано',
  'Не вказано ім\'я або прізвище',
  'Досвід вказано в одному полі',
  'Реклама послуг в резюме',
  'Некоректний текст / лексика',
];

export const warningReasons = [
  'Не вистачає даних про обов\'язки',
  'Не вказано місця роботи',
  'Не вказано посади',
  'Немає даних про рівень освіти',
  'Орфографічні помилки',
  'Текст різними мовами',
  'Текст набрано з CAPS LOCK',
  'Неякісне фото',
  'Імʼя вказано не в діловому стилі',
  'Зарплата вказана некоректно',
];
